// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"ChoosePPLForTransaction_PageHolder__3Zu8K","ImageTransaction":"ChoosePPLForTransaction_ImageTransaction__1C7BZ"};